import {Navigate} from 'react-router-dom';
import {NOT_FOUND_ROUTE} from '../tools/httpError';

const NotFoundRedirect = (): JSX.Element => <Navigate to={NOT_FOUND_ROUTE} replace />;

export default NotFoundRedirect;
